import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-chair-workouts': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_chair_workouts_male_subtitles~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_chair_workouts_male_subtitles'),
			},
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_chair_workouts_male_subtitles~1
			funnel: {
				id: 'ob-male-chair-workouts-subtitles',
				locale: ['en'],
			},
		},
	},
]

export default config
